import {equals, flow, makeGet} from '@yandex-delivery/utils'
import type {
  Action,
  ActionOpenRover,
  ActionWebTips,
  ExtendDeliveryExpirationDate,
  SharedRouteInfoResponse,
  WebPayNowAction,
} from 'src/api/types'
import {config} from 'src/shared/config'

type ActionsPayload = {
  headActions: Action[]
  footActions: Action[]
  paymentAction?: WebPayNowAction
  webTipsAction?: ActionWebTips
  extendExpirationAction?: ExtendDeliveryExpirationDate
  isShowFeedback: boolean
  openRoverActions: ActionOpenRover[]
}

const headActionTypes = ['open_universal_link', 'performer_call', 'deeplink', 'order_more']
const footActionTypes = ['cancel_v2', 'show_support_web', 'open_yandex_messenger_support_chat', 'open_chat']

function isWebPayNowAction(action: Action): action is WebPayNowAction {
  return action.type === 'pay_now_in_web'
}

function isWebTipsAction(action: Action): action is ActionWebTips {
  return action.type === 'web_tips'
}

function isRoverAction(action: Action): action is ActionOpenRover {
  return action.type === 'rover'
}

function isExtendExpirationAction(action: Action): action is ExtendDeliveryExpirationDate {
  return action.type === 'extend_delivery_expiration_date'
}

export function toActionsPayload(info: SharedRouteInfoResponse): ActionsPayload {
  const {actions = []} = info
  const initialActions: ActionsPayload = {
    headActions: [],
    footActions: [],
    isShowFeedback: false,
    openRoverActions: [],
  }

  if (info.performer) {
    initialActions.headActions.push({
      type: 'performer_badge',
      performer: info.performer,
    })
  }

  return actions.reduce<ActionsPayload>(function (acc: ActionsPayload, action: Action): ActionsPayload {
    if (headActionTypes.includes(action.type)) {
      acc.headActions.push(action)
    }
    if (isWebPayNowAction(action)) {
      acc.paymentAction = action
    }
    if (isWebTipsAction(action)) {
      acc.webTipsAction = action
    }
    if (footActionTypes.includes(action.type)) {
      acc.footActions.push(action)
    }
    if (action.type === 'feedback') {
      acc.isShowFeedback = true
    }
    if (isRoverAction(action)) {
      acc.openRoverActions.push(action)
    }
    if (isExtendExpirationAction(action)) {
      acc.extendExpirationAction = action
    }

    return acc
  }, initialActions)
}

export function isCountry(countryIsoCode: string) {
  const {country} = config

  return countryIsoCode === country
}

const infoGet = makeGet<SharedRouteInfoResponse>()

export const isBannerPositionUp: (routeInfo: SharedRouteInfoResponse) => boolean = flow(
  infoGet('promo_banner.banner_position'),
  equals('up'),
)
